/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-05-27 11:21
 * @LastEditors: yinping.che@ginlong.com
 * @LastEditTime: 2025-08-05 13:19
 * @FilePath: \glyun_web_vue3\src\const\global.js
 * @Description: 全局常量文件
 */
// import i18n from "@/lang/index"
// import i18n from '@/lang'
export default {
  systemLanguageOptions: {
    zh: '1',
    en: '2',
    es: '3',
    pl: '4',
    de: '5',
    fr: '6',
    ko: '7',
    nl: '8',
    pt: '9',
    it: '10',
    uk: '11',
    sv: '12',
    vi: '13',
    th: '14',
    ur: '15',
    ar: '16',
    tr: '17',
    cs: '18',
    bs: '19',
    ru: '20',
    fi: '21',
    ro: '22',
    nb: '23', //挪威
    da: '24', //丹麦
    lt: '25', //立陶宛
  },
  languageOptions: {
    '1': 'zh',
    '2': 'en',
    '3': 'es',
    '4': 'pl',
    '5': 'de',
    '6': 'fr',
    '7': 'ko',
    '8': 'nl',
    '9': 'pt',
    '10': 'it',
    '11': 'uk',
    '12': 'sv',
    '13': 'vi',
    '14': 'th',
    '15': 'ur',
    '16': 'ar',
    '17': 'tr',
    '18': 'cs',
    '19': 'bs',
    '20': 'ru',
    '21': 'fi',
    '22': 'ro',
    '23': 'nb', //挪威
    '24': 'da', //丹麦
    '25': 'lt', //立陶宛
  },
  // 业务字典语言接口：aliasCode -> code。
  // accept-language 使用接口返回的 code，通用 language 请求头仍使用上面的数字语言值。
  languageAliasCodeOptions: {
    zh: 'zh-CN',
    en: 'en-US',
    es: 'es-ES',
    pl: 'pl-PL',
    de: 'de-DE',
    fr: 'fr-FR',
    ko: 'ko-KR',
    nl: 'nl-NL',
    pt: 'pt-PT',
    it: 'it-IT',
    uk: 'uk-UA',
    sv: 'sv-SE',
    vi: 'vi-VN',
    th: 'th-TH',
    ur: 'ur-PK',
    ar: 'ar-SA',
    tr: 'tr-TR',
    cs: 'cs-CZ',
    bs: 'bs-BA',
    ru: 'ru-RU',
    fi: 'fi-FI',
    ro: 'ro-RO',
    nb: 'nb-NO',
    da: 'da-DK',
    lt: 'lt-LT',
  },
  langOptionsAll: [
    {
      value: '1',
      label: '中文',
    },{
      value: '2',
      label: 'English'
    },{
      value: '3',
      label: 'Español'
    },{
      value: '4',
      label: 'Polska'
    },{
      value: '5',
      label: 'Deutsch'
    },{
      value: '6',
      label: 'Français'
    },{
      value: '7',
      label: '한국어'
    },{
      value: '8',
      label: 'Nederlands'
    },{
      value: '9',
      label: 'Português'
    },{
      value: '10',
      label: 'Italiano'
    },{
      value: '11',
      label: 'Українська'
    },{
      value: '12',
      label: 'Svenska'
    },{
      value: '13',
      label: 'Tiếng Việt'
    },{
      value: '14',
      label: 'ภาษาไทย'
    },{
      value: '15',
      label: 'اردو'
    },{
      value: '16',
      label: 'اللغة العربية'
    },{
      value: '17',
      label: "Türkçe",
    },{
      value: '18',
      label: "čeština",
    },{
      value: '19',
      label: "bosanski",
    },{
      value: '20',
      label: "русский",
    },{
      value: '21',
      label: "suomi",
    },{
      value: '22',
      label: "limba română",
    },
    {
      value: '23',
      label: "Norsk",
    },{
      value: '24',
      label: "Dansk",
    },{
      value: '25',
      label: "Lietuvių kalba",
    },
  ],
  decimalPlaces: 3, // 小数位数
  invalidArr: [undefined, null, ''], // 无效值
  DATE_PICKER_TYPE: {
    date: 'yyyy-MM-dd',
    month: 'yyyy-MM',
    year: 'yyyy',
    daterange: 'yyyy-MM-dd',
  },
  inputLengthMax: 60, //输入框最大长度
  pwdLengthMin: 8, //密码长度
  pwdLengthMax: 32, //密码
  el_layout: 'total, sizes, prev, pager, next, jumper', //分页器样式
  el_layout2: 'sizes, prev, pager, next, jumper',
  textareaLengthMax: 1024, //多行文本长度
  inputIntervalTimer: 500, //输入框联想式搜索时间间隔

  roleCodeList: {
    //角色类型枚举
    owner: '000', // 业主
    charge: '001', // 负责人
    admin: '002', // 管理员
    maintenanceadmin: '003', // 运维管理员
    maintenance: '004', // 运维人员
    installer: '005', // 安装人员
    common: '006', // 普通用户
    distributor: '007', // 市场人员
    ginsuperAdmin: '101', // 锦浪超级管理员
    ginPrincipal: '102', // 锦浪负责人
    ginResearchAndDevelopment: '103', //锦浪杭州研发
    ginProduct: '104', //锦浪产品
    ginPilotTest: '105', //锦浪中试
    ginTechnicalSupport: '106', //锦浪技术支持
    ginHeadquartersAfterSales: '107', //锦浪总部售后
    ginAfterSalesAbroad: '108', //锦浪驻外售后
    ginFinance: '110', //锦浪财务
    ginOperation: '111', //锦浪运营
    aging: '202', // 老化
    icbcadmin: '301', //工行管理员
    icbcmaintenance: '302', //工行运维人员 //晴天代理
    nmiControl: '310', //NMI控制人员
  },
  pageSizeArr: [10, 20, 40, 60, 100], //分页
  deviceTypeMap: {
    2: '采集器',
    3: '逆变器',
    4: 'EPM',
    5: '电表',
    7: '气象仪',
    8: '充电桩',
    9: '电池',
  },
  tableThMinWidth: 140, //列表最小宽度
  $accessType_zh: 'zh',
  $accessType_en: 'en',
}
